var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"time"},[_c('Icon',{attrs:{"type":"ios-time","color":"#FF9D00","size":"22"}}),_vm._v(_vm._s(_vm.hour)+"："+_vm._s(_vm.minite)+"："+_vm._s(_vm.second))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /Users/wangmengyuan/Code/xbz-students-web/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b5b0304","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/Users/wangmengyuan/Code/xbz-students-web/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/practise/components/countTime.vue
// module id = null
// module chunks = 